import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { ArrowRight, Layers } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-atomic-black pt-20" data-id="element-137">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-138">
        <img src="https://images.unsplash.com/photo-1626785774573-4b799314348d?q=80&w=2070&auto=format&fit=crop" alt="Screen printing production floor" className="w-full h-full object-cover opacity-40" data-id="element-139" />
        <div className="absolute inset-0 bg-gradient-to-t from-atomic-black via-atomic-black/80 to-atomic-black/40" data-id="element-140" />
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-141" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-142">
        <div className="max-w-4xl mx-auto text-center" data-id="element-143">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-atomic-green text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-144">
            <Layers size={14} data-id="element-145" />
            <span data-id="element-146">Premium Commercial Production</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6 leading-tight" data-id="element-147">
            Custom Apparel & <br className="hidden md:block" data-id="element-148" />
            DTF Transfers —{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-atomic-green to-lime-400" data-id="element-149">
              Fast. Reliable. Atomic.
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-150">
            The premier production partner for brands, teams, and businesses.
            High-volume DTF transfers, screen printing, and embroidery with
            commercial-grade precision.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-151">
            <Button size="lg" className="w-full sm:w-auto group" data-id="element-152">
              Get a Quote
              <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-153" />
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-154">
              View Services
            </Button>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-gray-500" data-id="element-155">
        <span className="text-xs uppercase tracking-widest" data-id="element-156">Scroll</span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-atomic-green to-transparent" data-id="element-157"></div>
      </motion.div>
    </section>;
}